import React, { useEffect, useState, useRef, useContext } from 'react';
import styles from './MoreInfo.module.css';
import { MdInfo } from 'react-icons/md';
import { BookingsContext } from '../BookingContext';
import { BreathAPIs } from '../../../../APIs/BreathAPIs';
import DaySelector from '../../../../GeneralComponents/DaySelector';
import Tab from './components/Tab';

import { BiSolidDollarCircle } from "react-icons/bi";
import { IoLocationSharp } from "react-icons/io5";
import { MdPrivacyTip } from "react-icons/md";

import { ImPowerCord } from "react-icons/im";
import { FaChargingStation } from "react-icons/fa";
import { FaPlug } from "react-icons/fa6";






const MoreInfo = ({ rate, freeTime, idleFees, locationData, chargerData, userGroups, usersFreeChargingLocations, allChargingStations, view = 'menuView', nonResDis }) => {
  // console.log("Charger Data moreinfo", chargerData, allChargingStations)
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [chargerRate, setChargerRate] = useState(chargerData[0]?.dynamicRates);
  const [normalRate, setNormalRate] = useState(chargerData[0]?.normalRate);
  const [days, setDays] = useState(["S", "M", "T", "W", "T", "F", "S"]);

  const [isFreeChargingForSelectedLocation, setIsFreeChargingForSelectedLocation] = useState(false)
  const [isCustomEnergyRateForSelectedLocation, setIsCustomEnergyRateForSelectedLocation] = useState(false)
  const [customEnergyRate, setCustomEnergyRate] = useState(0)

  const getChargerData = async() => {
    try{
      // console.log("id for charger fetch: ", locationData[0]._id)
      let res = await BreathAPIs.getAllChargerByLocation(locationData[0]?._id)
      // console.log('response : ', res.data)
      // console.log(res.status)
      if(res.status == 200){
        // console.log(res.data.data.dynamicRates)
        // console.log(res.data.data.rate.price_components.price)
        setChargerRate(res.data.data.dynamicRates)
        setNormalRate(res.data.data.rate.price_components.price)
      }
    }catch(err){
      console.log(err.message)
    }
  }

  useEffect(()=>{
    if (chargerData.length == 0 && locationData[0]?._id) {
      getChargerData()
    }
  }, [locationData])

  // keep local rate state in sync when chargerData prop updates
  useEffect(() => {
    if (chargerData[0]) {
      setChargerRate(chargerData[0]?.dynamicRates)
      setNormalRate(chargerData[0]?.normalRate)
    }
  }, [chargerData])

  // console.log("chargerData",chargerData)

  // const countByConnectorType = chargerData.reduce((acc, charger) => {
  //   acc[charger.connectorType] = (acc[charger.connectorType] || 0) + 1;
  //   return acc;
  // }, {});
  // console.log("allChargingStations", allChargingStations)
  const countByConnectorType = allChargingStations.reduce((acc, charger) => {
    const { connectorType, nonReservable, chargerStatus } = charger;

    // Initialize the structure for each connectorType if not already present
    if (!acc[connectorType]) {
      acc[connectorType] = {
        connectorType,
        resAllChargers: 0,
        resOnlineChargers: 0,
        nonResAllChargers: 0,
        nonResOnlineChargers: 0,
      };
    }

    // Update counts based on reservable and status
    if (nonReservable) {
      acc[connectorType].nonResAllChargers += 1;
      if (chargerStatus === 'Online') {
        acc[connectorType].nonResOnlineChargers += 1;
      }
    } else {
      acc[connectorType].resAllChargers += 1;
      if (chargerStatus === 'Online') {
        acc[connectorType].resOnlineChargers += 1;
      }
    }

    return acc;
  }, {});

  const countConnectorByAvaailability = allChargingStations.reduce((acc, charger) => {
    const { connectorType, nonReservable, chargerStatus, status, power } = charger;
    const isAvailable = chargerStatus === 'Online' && status === 'Available' ;
    if(!acc[connectorType]) {
      acc[connectorType] = {
        power,
        connectorType,
        available: 0,
        inUse: 0
      };
    }
    if (nonReservable === true) {
      if (isAvailable) {
        acc[connectorType].available += 1;
      } else {
        acc[connectorType].inUse += 1;
      }
    }
    return acc;
  }, {});

  // console.log(countByConnectorType)

  function isFreeChargingAllowedInSelectedLocation(locationsFromPermission = []) {

    if (usersFreeChargingLocations.includes(locationData[0]?._id)) {
      //  console.log("1")
      return true
    }
    if (locationsFromPermission.includes(locationData[0]?._id)) {
      // console.log("2")
      return true
    }
    // }
    if (usersFreeChargingLocations.length === 0 && locationsFromPermission.length === 0) {
      // console.log("3")
      return true
    }
    return false;
  }

  function isCustomEnergyRateEnabledInSelectedLocation(customEnergyRateEnabledLocations = null) {
    try {
      if (customEnergyRateEnabledLocations) {
        if (customEnergyRateEnabledLocations.length === 0) {
          return true
        } else {
          if (customEnergyRateEnabledLocations.includes(locationData[0]?._id)) {
            return true
          } else {
            return false
          }
        }
      }
    } catch (error) {
      console.log(error.message)
    }

  }
  // console.log("Locaiton", locationData)
  useEffect(() => {

    userGroups.map((ug) => {
      let parsedPermissions = JSON.parse(ug.permissions)
      // console.log("parsedPer",parsedPermissions)
      if (parsedPermissions.freeCharging && parsedPermissions.freeCharging === 'allowed') {
        let isFreecharging = false
        if ("freeChargingAllowedLocations" in parsedPermissions) {
          isFreecharging = isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations)
        } else {
          isFreecharging = isFreeChargingAllowedInSelectedLocation()
        }
        isFreecharging ? setIsFreeChargingForSelectedLocation(true) : setIsFreeChargingForSelectedLocation(false)
      }

      if (parsedPermissions?.customEnergyRate && parsedPermissions?.customEnergyRate === 'enabled') {
        let isCustomEnergyRateEnabled = false
        if ("customEnergyRateEnabledLocations" in parsedPermissions) {
          isCustomEnergyRateEnabled = isCustomEnergyRateEnabledInSelectedLocation(parsedPermissions.customEnergyRateEnabledLocations)
        } else {
          isCustomEnergyRateEnabled = true
        }


        if (isCustomEnergyRateEnabled) {
          setIsCustomEnergyRateForSelectedLocation(true)
          setCustomEnergyRate(parsedPermissions?.customEnergyRateEnabledRate)
        } else {
          setIsCustomEnergyRateForSelectedLocation(false)
          setCustomEnergyRate(0)
        }
      }
    })
  }, [locationData])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        // only update rates when we actually have charger data to avoid overwriting with undefined
        if (chargerData[0]) {
          setChargerRate(chargerData[0]?.dynamicRates)
          setNormalRate(chargerData[0]?.normalRate)
        }
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [chargerData]);

  const convertToTimezone = (timeString, targetZone = locationData[0]?.timezone) => {
    const [start, end] = timeString.split('-');
    const getDateWithTime = (time, position) => {
      // Create a date object assuming the time is in UTC (can adjust if needed)
      const [hours, minutes, seconds] = time.split(':');
      const date = new Date();
      date.setUTCHours(hours);
      date.setUTCMinutes(minutes);
      date.setUTCSeconds(seconds);
      date.setUTCMilliseconds(position === "start" ? 0 : 999)
      return date;
    };
    const formatTime = (date, timeZone) => {
      return date.toLocaleString('en-US', {
        timeZone: timeZone,
        hour12: true,
        hour: '2-digit',
        minute: '2-digit'
      });
    };
    const startTimeDate = getDateWithTime(start, "start");
    const endTimeDate = getDateWithTime(end, "end");
    let adjustedEndDate = new Date(endTimeDate.getTime() + 1)
    const convertedStartTime = formatTime(startTimeDate, targetZone);
    const convertedEndTime = formatTime(adjustedEndDate, targetZone);
    return `${convertedStartTime} - ${convertedEndTime}`;
  };


  const handleButtonClick = () => {
    const nextOpen = !isOpen;
    setIsOpen(nextOpen);
    // when opening, ensure we have charger data (handles case when locationData arrives later)
    if (nextOpen && chargerData.length === 0 && locationData[0]?._id) {
      getChargerData()
    }
  };

  let rateUI = {
            hidden: locationData[0] ? false : true,
            headName: <><BiSolidDollarCircle />Rate</>, content:
              <>
                <div className={styles['more-info']}>
                  <div className={styles['more-info-block']}>
                    {
                      isFreeChargingForSelectedLocation ?
                        <>
                        <div className={styles['list']}>Rate:<span>$0.00</span> per kWh</div>
                        <div className={styles['list']}>Idle Fees:<span>$0.00</span> per minute</div>
                        </>
                        :
                        <>
                          {
                            locationData[0]?.rateType === "fixed" ?
                              rate && <> <div className={styles['list']}>Rate:
                                <span>
                                  {isCustomEnergyRateForSelectedLocation ? `$${customEnergyRate ? customEnergyRate.toFixed(2) : "0.00"}`
                                    :
                                    `$${chargerData[0]?.normalRate ? chargerData[0]?.normalRate.toFixed(2) : (normalRate ? normalRate : "0.00")}`}
                                </span> per kWh
                              </div>
                              {(locationData[0]?.showRateSplitInfo && locationData[0]?.revenueModel[locationData[0].revenueModel.length - 1].revenueType == 'rev_share') &&
                                        <ul className={styles['rate-split-list']}>
                                          <li>Property Energy Cost - ${(chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF).toFixed(2)} </li>
                                          <li>BreatheEV Fee - ${(chargerData[0]?.normalRate - (chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF)).toFixed(2)} </li>
                                        </ul>
                                      }
                                      </>
                              :
                              !isCustomEnergyRateForSelectedLocation ?
                                <>
                                  {rate && <div className={styles['list']}>
                                    <div className={styles.timezoneSpan}>
                                      <span>Dynamic Rates </span> <span >({locationData[0]?.timezone})</span>
                                    </div>
                                    <div className={styles.tableDiv}>
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Time Range</th>
                                            <th>Rate</th>
                                            <th>Applicable Days</th>
                                          </tr>
                                        </thead>
                                        <tbody>

                                          {chargerData[0]?.dynamicRates && chargerData[0]?.dynamicRates.map((item, index) => {
                                            const timeRange = convertToTimezone(item.timeRange);
                                            return (
                                              <tr key={index}>
                                                <td>{timeRange}</td>
                                                <td>$ {item.rate?.toFixed(2) || "0.00"}</td>
                                                <td className={styles.daySelectionDiv}>
                                                  {/* {item.applicableDays} */}
                                                  {days.map((day, index) => {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={`${styles.dayDiv} ${item.applicableDays[index] === 1 ? styles.enabledDay : styles.disabledDay}`}
                                                      >
                                                        {day}
                                                      </div>
                                                    );
                                                  })}
                                                </td>
                                              </tr>
                                            );
                                          })}

                                        </tbody>
                                      </table>
                                    </div>
                                    {chargerData[0]?.normalRate !== undefined &&<> <div className={styles['list']}>Regular Rate:
                                      <span>
                                        {`$${chargerData[0]?.normalRate?.toFixed(2)}`}
                                      </span> per kWh
                                    </div>
                                      {(locationData[0]?.showRateSplitInfo && locationData[0]?.revenueModel[locationData[0].revenueModel.length - 1].revenueType == 'rev_share') &&
                                        <ul className={styles['rate-split-list']}>
                                          <li>Property Energy Cost - ${(chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF).toFixed(2)} </li>
                                          <li>BreatheEV Fee - ${(chargerData[0]?.normalRate - (chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF)).toFixed(2)} </li>
                                        </ul>
                                      }
                                      </>
                                    }
                                  </div>}
                                </> : <>
                                  {
                                    rate && <div className={styles['list']}>Rate:
                                      <span>
                                        {`$${customEnergyRate ? customEnergyRate.toFixed(2) : "0.00"}`}
                                      </span> per kWh
                                    </div>
                                  }
                                  {(rate &&(locationData[0]?.showRateSplitInfo && locationData[0]?.revenueModel[locationData[0].revenueModel.length - 1].revenueType == 'rev_share') )&&
                                        <ul className={styles['rate-split-list']}>
                                          <li>Property Energy Cost - ${(chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF).toFixed(2)} </li>
                                          <li>BreatheEV Fee - ${(chargerData[0]?.normalRate - (chargerData[0]?.normalRate * locationData[0].revenueModel[locationData[0].revenueModel.length - 1].RSF)).toFixed(2)} </li>
                                        </ul>
                                      }
                                </>
                          }
                          {(idleFees && idleFees !== 'undefined') && <div className={styles['list']}>Idle Fees: <span>{`$${Number(idleFees)?.toFixed(2)}`}</span> per minute</div>}
                          {<div className={styles['list']}>Parking Fees: <span>$0.00</span></div>}
                          {chargerData[0] && <div className={styles['list']}>Tax: <span>{chargerData[0]?.tax ? chargerData[0]?.tax : "0"} %</span> </div>}
                          {freeTime && <div className={styles['list']}>Free charging time: <span>{freeTime}</span></div>}
                          

                        </>

                    }
                  </div>
                </div>
              </>
          };
          let infoUINonRes = 
          {
            hidden: locationData[0] ? false : true,
            headName: <><FaPlug /> Info</>, content:
              <>
                <div className={styles['more-info']}>
                  <div className={styles['more-info-block']}>

                    <div className={styles.tableDiv}>
                      <table border="1" cellPadding="8">
                        <thead>
                          <tr>
                            <th><ImPowerCord /> Type</th>
                            <th className='text-center'> <span className={`${styles.statusDot} ${styles.available}`} aria-label="available" title="Available" /> Available</th>
                            <th className='text-center'> <span className={`${styles.statusDot} ${styles.inUse}`} aria-label="in-use" title="In Use" /> In Use</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(countConnectorByAvaailability).map(([key, value]) => (
                            <tr key={key}>
                              <td>{value.connectorType} <span className={styles.powerValue}>({value.power}kW)</span></td>
                              <td className='text-center'><b style={{ fontWeight: 600 }}>{value.available}</b><i></i></td>
                              <td className='text-center'><b style={{ fontWeight: 600 }}>{value.inUse}</b><i></i></td>
                            </tr>
                          ))}
                          {Object.entries(countConnectorByAvaailability).length === 0 &&
                            <tr>
                              <td align='center' colSpan={3}>-No chargers available-</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </>
          };

          let infoUI = {
            hidden: locationData[0] ? false : true,
            headName: <><FaPlug /> Info</>, content:
              <>
                <div className={styles['more-info']}>
                  <div className={styles['more-info-block']}>

                    <div className={styles.tableDiv}>
                      <table border="1" cellPadding="8">
                        <thead>
                          <tr>
                            <th><ImPowerCord /> Type</th>
                            <th className='text-center'><FaChargingStation /> Reservable</th>
                            <th className='text-center'><FaChargingStation /> Non-reservable</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(countByConnectorType).map(([key, value]) => (
                            <tr key={key}>
                              <td>{value.connectorType}</td>
                              <td className='text-center'><b style={{ fontWeight: 600 }}>{value.resOnlineChargers}</b><i></i></td>
                              <td className='text-center'><b style={{ fontWeight: 600 }}>{value.nonResOnlineChargers}</b><i></i></td>
                            </tr>
                          ))}
                          {Object.entries(countByConnectorType).length === 0 &&
                            <tr>
                              <td align='center' colSpan={3}>-No chargers available-</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </>
          };

          let policyUI = {
            headName: <><MdPrivacyTip />Policy</>, content:
              <>
                <div className={styles['more-info']}>
                  <div className={styles['more-info-block']}>
                    <span>Cancellation Policy:</span>
                    <ul>
                      <li>You may cancel your booking free of charge within 15 minutes of receiving booking confirmation, or up to 12 hours before the scheduled start time of your booking.</li>
                      <li>Cancellations fee is equivalent to 100% of the estimated booking amount.</li>
                    </ul>
                    <span>No-Show Policy:</span>
                    <ul>
                      <li>To ensure the optimal utilization of our EV charging stations and maintain a reliable service for all users, BreatheEV has implemented a No-Show Policy. If you fail to utilize your reserved charging slot without canceling within the designated timeframe, a No-Show Fee will be applied to your account.</li>
                      <li>This fee will be equivalent to the full value of the booking, calculated based on the maximum charging rate and the duration of the reserved time slot. This policy is in place to encourage responsible usage and availability of our charging services for all members of our community.</li>
                    </ul>
                    <span>Unutilized Time Fee Policy:</span>
                    <ul>
                      <li>No fee for unutilized time will be charged if you use more than 70% of your reserved charging duration, excluding your grace period.</li>
                      <li>However, if your usage is less than 70% of the reserved charging duration, an unutilized time fee, amounting to the estimated energy to reach the 70% of reserved charging duration, will apply.</li>
                    </ul>
                  </div>
                </div>

              </>
          };

  const InternalItems = () => {
    return <div className={`${styles['more-info-container-menu']} ${view !== 'menuView' ? styles['display'] : ''}`}>

{/* {console.log("Location data moreinfo", locationData[0])} */}
      <Tab tabItems={
        [
          rateUI,
          infoUI,
          policyUI,
        ]
      } />

    </div>
  }

  const InternalItemsNonRes = () => {
    return <div className={`${styles['more-info-container-menu']} ${view !== 'menuView' ? styles['display'] : ''}`}>

{/* {console.log("Location data moreinfo", locationData[0])} */}
      <Tab tabItems={
        [
          infoUINonRes,
          rateUI,
          policyUI,
        ]
      } />

    </div>
  }


  return (
    <>
      {view === 'menuView' ? (
        <div className={styles['more-info-container']} ref={containerRef}>
          <button onClick={handleButtonClick} className={styles['btn-more-info']}>
            <MdInfo />
            <span>Info</span>
          </button>
          {isOpen && (
            InternalItems()
          )}
        </div>
      ) : (
        (nonResDis && view==='normal')?
            InternalItemsNonRes() 
              :
            InternalItems()
      )}
    </>
  );

}
export default MoreInfo;

